/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { RestoreSecurityGroupsSecurityGroupsInner } from '../models/RestoreSecurityGroupsSecurityGroupsInner';

export class RestoreSecurityGroups {
  /**
  * The region to restore
  */
  'region': string;
  /**
  * The available zones for the region
  */
  'securityGroups': Array<RestoreSecurityGroupsSecurityGroupsInner>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "securityGroups",
      "baseName": "securityGroups",
      "type": "Array<RestoreSecurityGroupsSecurityGroupsInner>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreSecurityGroups.attributeTypeMap;
  }

  public constructor() {
  }
}

